module.exports = __webpack_public_path__ + "img/send.e461f38a.png";